var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tab-pane fade",
    class: {
      'show active': _vm.isActive
    },
    attrs: {
      "id": "nav-gifting",
      "role": "tabpanel",
      "aria-labelledby": "nav-gifting-tab"
    }
  }, [_c('div', {
    staticClass: "gifting"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "gifting-card"
  }, [_c('div', {
    staticClass: "gifting-subtabs",
    attrs: {
      "role": "tablist"
    }
  }, _vm._l(_vm.tabs, function (tab) {
    return _c('a', {
      key: tab.id,
      staticClass: "gifting-subtab",
      class: {
        active: _vm.activeTab === tab.id
      },
      attrs: {
        "role": "tab",
        "aria-selected": _vm.activeTab === tab.id ? 'true' : 'false',
        "href": "#"
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          _vm.activeTab = tab.id;
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.activeTab === tab.id ? tab.iconActive : tab.iconIdle,
        "alt": tab.title
      }
    }), _c('span', [_c('strong', [_vm._v(_vm._s(tab.title))]), _c('small', [_vm._v(_vm._s(tab.subtitle))])])]);
  }), 0), _vm.opened ? _c('keep-alive', [_vm.activeTab === 'gems' ? _c('GiftingGems') : _c('AnonymousGifting')], 1) : _vm._e()], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }